// @flow

import type {Tag, RenderableTreeNode} from '@markdoc/markdoc';
import {isMarkdocAstTag} from 'docs/util';

export const findMarkdocTag = (
  renderNodes: Array<RenderableTreeNode>,
  predicate: (tag: Tag) => boolean,
): ?Tag => {
  for (const tag of renderNodes) {
    if (isMarkdocAstTag(tag) && predicate(tag)) {
      return tag;
    }
  }
};

export const filterMarkdocTags = (
  renderNodes: Array<RenderableTreeNode>,
  predicate: (tag: Tag) => boolean,
): Array<Tag> => {
  const tags = [];
  for (const tag of renderNodes) {
    if (isMarkdocAstTag(tag) && predicate(tag)) {
      tags.push(tag);
    }
  }
  return tags;
};
